import { useCallback } from "react";

import { LANG_EN } from "@/constants/Language";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useAssignmentCreate = () => {
  const createAssignmentPostRequest = useCallback((payload) => {
    const finalPayload = payload;
    const classrooms = payload.assignment_classrooms.map((classroom) => {
      classroom.classroom_id = classroom.id;
      delete classroom.id;
      return classroom;
    });
    finalPayload.assignment_classrooms = classrooms;
    const urlParams = new URLSearchParams(window.location.search);
    finalPayload.language = urlParams.get("language") || LANG_EN;
    const requestConfig = {
      method: "POST",
      body: JSON.stringify(finalPayload),
      headers: { "Content-Type": "application/json" },
    };

    // The user is editing an assignment that already exists AND they're not creating from a copied assignment.
    // Cloned assignments in the existing assignment flow send the content_id of the assignment
    // being cloned as a part of the payload, which makes this check necessary.
    if (finalPayload.content_id && !finalPayload.copied_from_assignment) {
      return new Request(
        `${MONOLITH_ORIGIN}/api/v3/assignment/${finalPayload.content_id}/`,
        requestConfig,
      );
    } else {
      // creating a new assignment
      return new Request(
        `${MONOLITH_ORIGIN}/api/v3/assignment/`,
        requestConfig,
      );
    }
  }, []);
  return useRestMutation(createAssignmentPostRequest);
};

export default useAssignmentCreate;
